export function obfuscateEmail(email: string): string {
  const [user, domain] = email.split('@');
  if (!user || !domain) {
    return '[INVALID_EMAIL]';
  }
  if (user.length <= 2) {
    return `${user[0] + (user.length === 2 ? `*${user[1]}` : '*')}@${domain}`;
  }
  return `${user[0]}***${user[user.length - 1]}@${domain}`;
}

/* biome-ignore lint/suspicious/noExplicitAny: Unknown type */
function isUserObject(obj: any): boolean {
  return (
    obj &&
    typeof obj === 'object' &&
    typeof obj.email === 'string' &&
    typeof obj.name === 'string'
  );
}

/* biome-ignore lint/suspicious/noExplicitAny: Unknown type */
export function redactPII(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(redactPII);
  }
  if (obj && typeof obj === 'object') {
    /* biome-ignore lint/suspicious/noExplicitAny: Unknown type */
    const redacted: any = {};
    const isUser = isUserObject(obj);
    for (const key of Object.keys(obj)) {
      if (key.toLowerCase() === 'email' && typeof obj[key] === 'string') {
        redacted[key] = obfuscateEmail(obj[key]);
      } else if (
        isUser &&
        key.toLowerCase() === 'name' &&
        typeof obj[key] === 'string'
      ) {
        redacted[key] = '[REDACTED]';
      } else {
        redacted[key] = redactPII(obj[key]);
      }
    }
    return redacted;
  }
  return obj;
}
